import { Menu } from '@mantine/core';
import { formatDateTime } from 'src/meetings/utils/date-utils';
import DocumentCard, { DocumentCardTag } from './DocumentCard';

export type GeneratedDocumentType =
  | 'suitability-report'
  | 'meeting-agenda'
  | 'data-export'
  | 'meeting-note';

export const GENERATED_DOCUMENT_TYPE_LABELS: Record<GeneratedDocumentType, string> = {
  'suitability-report': 'Suitability report',
  'meeting-agenda': 'Meeting agenda',
  'data-export': 'Data export',
  'meeting-note': 'Meeting note',
};

type GeneratedDocumentCardProps = {
  displayName: string;
  documentType: GeneratedDocumentType;
  createdAt: string;
  fileId?: number;
  onDownload: (fileId: number) => void;
  onDelete: () => void;
};

export default function GeneratedDocumentCard({
  displayName,
  documentType,
  createdAt,
  fileId,
  onDownload,
  onDelete,
}: GeneratedDocumentCardProps) {
  const tags: DocumentCardTag[] = [
    { label: GENERATED_DOCUMENT_TYPE_LABELS[documentType] },
    { label: `Generated: ${formatDateTime(createdAt)}` },
  ];

  return (
    <DocumentCard
      fileName={displayName}
      tags={tags}
      menuItems={
        <>
          {fileId !== undefined && (
            <Menu.Item onClick={() => onDownload(fileId)}>Download document</Menu.Item>
          )}
          <Menu.Item onClick={onDelete}>Delete</Menu.Item>
        </>
      }
    />
  );
}
